/* istanbul ignore file -- api call */
import { useToken } from '@ori/auth';
import {
  getApplicationsNavigationCustomerInfo,
  useApiClient as useGlobalApiClient,
} from '@ori/global-api-client-react';
import type {
  GetTenantApplicationsNavigationNavigationParams,
  StaticNavigationNavigationItemDto,
  StaticNavigationNavigationItemDtoType,
} from '@ori/static-api-client-react';
import {
  getTenantApplicationsNavigationNavigation,
  useApiClient as useStaticApiClient,
} from '@ori/static-api-client-react';
import { useCallback } from 'react';

import { useAppConfig } from '../context';

export const useFetchNavigationItems = (): ((
  navigationType: StaticNavigationNavigationItemDtoType,
) => Promise<StaticNavigationNavigationItemDto[]>) => {
  const { tenant, currentLanguage } = useAppConfig();
  const globalApiClient = useGlobalApiClient();
  const staticApiClient = useStaticApiClient();
  const { isAnonymousUser } = useToken();
  const { customerId } = useToken();

  return useCallback(
    async (navigationType: StaticNavigationNavigationItemDtoType) => {
      const requestOptions: GetTenantApplicationsNavigationNavigationParams = {
        excludeChildren: false,
        lang: currentLanguage,
      };

      if (!isAnonymousUser) {
        const { data: customerInfo } = await getApplicationsNavigationCustomerInfo(
          globalApiClient,
          customerId.toString(),
        );
        requestOptions.customerTypeId = customerInfo.customerType?.customerTypeId;
        requestOptions.visitorSegment = customerInfo.visitorSegment;
      }

      const { data: responseNavigation } = await getTenantApplicationsNavigationNavigation(
        staticApiClient,
        tenant,
        navigationType,
        requestOptions,
      );

      return responseNavigation.navigationCollection;
    },
    [currentLanguage, customerId, globalApiClient, isAnonymousUser, staticApiClient, tenant],
  );
};
